/* eslint-disable no-shadow */

/* eslint-disable consistent-return */

/* eslint-disable no-unused-expressions */

/* eslint-disable camelcase */

/* eslint-disable react-hooks/exhaustive-deps */

import Box from '@material-ui/core/Box';
import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { IconErro } from '../../../assets/images';
import CustomButton from '../../../components/CustomButton/CustomButton';
import CustomModal from '../../../components/CustomModal/CustomModal';
import ModalFormAcessoPJ from '../../../components/ModalFormAcessoPJ';
import { LABELS, OPUS_ERROR_ENUM } from '../../../consts/text/acesso-pj';
import ScreenLoader from '../../../containers/ScreenLoader';
import { getParameterByName } from '../../../library/utils';
import AutenticationService from '../../../services/autentication';
import { AutenticationActions } from '../../../store/ducks/autentication';
import { loginOAuthBBOpinPage } from '../const';
import { isValidToken } from '../../../utils/validations/custom-validations';

const { apiUrl, bbNaoCorrentistaURL, bbCorrentistaURL, bbCorrentistaURLOpin } =
    loginOAuthBBOpinPage;

const authenticationService = new AutenticationService();
// eslint-disable-next-line react/function-component-definition
const LoginOAuthBBOpin = () => {
    const navigate = useNavigate();
    const handleLoader = useRef();
    const code = getParameterByName('code');
    const token = getParameterByName('token');
    const type_account = localStorage.getItem('type_account');
    const commandId = localStorage.getItem('commandId');
    const jti = localStorage.getItem('jti');
    const dispatch = useDispatch();
    const { dadosCliente } = useSelector((state) => state.autenticacao);
    const [error, setError] = useState(null);
    const [modalAcessoPj, setModalAcessoPj] = useState(false);

    const loginBBAuthBackend = async () => {
        const url = `${apiUrl}`;
        await axios
            .post(
                url,
                {
                    userName: process.env.REACT_APP_OPIN_USERNAME,
                    password: process.env.REACT_APP_OPIN_PASSWORD,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                },
            )
            .then((res) => {
                localStorage.setItem('tokenBBAuth', res.data.token);
            });
    };

    const createRedirectOpin = useCallback(async (res) => {
        handleLoader.current.handleControl();

        if (res.command === 'error') {
            return {
                error: true,
                errorType: res.errorCommand.type,
                url: `${res.errorCommand.redirect.redirectTo}`,
            };
        }
        if (res.command === 'completed') {
            return {
                error: false,
                url: `${res.completedCommand.redirect.redirectTo}`,
            };
        }
    }, []);

    const loginCorrentistaOpus = useCallback(async (cpf) => {
        try {
            const cpfParam = cpf ? `&cpf=${cpf}` : '';
            const url = `${bbCorrentistaURL}?commandId=${commandId}&jti=${jti}&bbOauthCode=${code}${cpfParam}`;

            const resultRedirect = await axios.get(url, {
                headers: {
                    Authorization: `${localStorage.getItem('tokenBBAuth')}`,
                },
            });

            const redirect = await createRedirectOpin(
                resultRedirect.data.resultado,
            );

            if (redirect.error) {
                setError({ errorType: redirect.errorType });
                dispatch(
                    AutenticationActions.setDadosCliente({
                        redirectUrl: redirect.url,
                    }),
                );

                return { redirectUrl: null, sucesso: false };
            }

            return { redirectUrl: redirect.url, sucesso: true };
        } catch (_) {
            setError({
                errorType: OPUS_ERROR_ENUM.GENERIC_ERROR,
            });

            return { redirectUrl: null, sucesso: false };
        }
    }, []);

    const loginNaoCorrentistaOpus = useCallback(
        async (cpf) => {
            try {
                const cpfParam = cpf ? `&cpf=${cpf}` : '';
                const url = `${bbNaoCorrentistaURL}?commandId=${commandId}&jti=${jti}&jwtTokenZuul=${token}${cpfParam}`;

                const resultRedirect = await axios.get(url, {
                    headers: {
                        Authorization: `${localStorage.getItem('tokenBBAuth')}`,
                    },
                });

                const redirect = await createRedirectOpin(
                    resultRedirect.data.resultado,
                );

                if (redirect.error) {
                    setError({ errorType: redirect.errorType });
                    dispatch(
                        AutenticationActions.setDadosCliente({
                            redirectUrl: redirect.url,
                        }),
                    );

                    return { redirectUrl: null, sucesso: false };
                }

                return { redirectUrl: redirect.url, sucesso: true };
            } catch (_) {
                setError({
                    errorType: OPUS_ERROR_ENUM.GENERIC_ERROR,
                });

                return { redirectUrl: null, sucesso: false };
            }
        },
        [commandId, jti, token],
    );

    const loginCorrentista = useCallback(async () => {
        if (!code) {
            handleLoader.current.handleControl();
            navigate(`/authconsent#${commandId}`);
        } else {
            try {
                if (type_account === 'correntista') {
                    setError(null);

                    const { searchParams } = new URL(
                        window.location.toString(),
                    );
                    const code = searchParams.get('code');
                    const { data: dataUsuario } = await axios.get(
                        bbCorrentistaURLOpin,
                        {
                            headers: {
                                authbbcode: code,
                                Authorization: `${localStorage.getItem(
                                    'tokenBBAuth',
                                )}`,
                            },
                        },
                    );

                    const isPessoaFisica =
                        dataUsuario?.dado?.atributos?.inPessoaFisica;
                    const cpfCnpj = dataUsuario?.dado?.atributos?.cdCpfCnpj;

                    if (isPessoaFisica) {
                        const { redirectUrl, sucesso } =
                            await loginCorrentistaOpus();

                        if (redirectUrl && sucesso) {
                            window.location.href = redirectUrl;
                        }
                        return;
                    }

                    dispatch(
                        AutenticationActions.setDadosCliente({
                            isPessoaFisica,
                            cpfCnpj,
                            tipoConta: 'correntista',
                        }),
                    );

                    setModalAcessoPj(true);
                }
            } catch (_) {
                setError({
                    errorType: OPUS_ERROR_ENUM.GENERIC_ERROR,
                });
            }
        }
    }, [navigate, setError, createRedirectOpin, AutenticationActions, dispatch]);

    const loginNaoCorrentista = useCallback(async () => {
        if (!token) {
            handleLoader.current.handleControl();
            navigate(`/authconsent#${commandId}`);
        } else {
            try {
                if (type_account === 'naoCorrentista') {
                    setError(null);
                    const { data: dataListarCliente } =
                        await authenticationService.postListarCliente(token);

                    const isPessoaFisica =
                        dataListarCliente?.resultado?.isPessoaFisica;
                    const cpfCnpj = dataListarCliente?.resultado?.cpfCnpj;

                    if (isPessoaFisica) {
                        const { redirectUrl, sucesso } =
                            await loginNaoCorrentistaOpus();

                        if (redirectUrl && sucesso) {
                            window.location.href = redirectUrl;
                        }
                        return;
                    }

                    dispatch(
                        AutenticationActions.setDadosCliente({
                            isPessoaFisica,
                            cpfCnpj,
                            tipoConta: 'naoCorrentista',
                        }),
                    );

                    setModalAcessoPj(true);
                }
            } catch (_) {
                setError({
                    errorType: OPUS_ERROR_ENUM.GENERIC_ERROR,
                });
            }
        }
    }, [navigate, setError, createRedirectOpin, AutenticationActions, dispatch]);

    useEffect(() => {
        isValidToken(code) &&
            loginBBAuthBackend().then(() => loginCorrentista());
        isValidToken(token) &&
            loginBBAuthBackend().then(() => loginNaoCorrentista());
    }, []);

    const handleCloseErrorModal = () => {
        setError(null);

        if (dadosCliente?.redirectUrl) {
            window.location.href = dadosCliente?.redirectUrl;
        } else {
            navigate('/');
        }
    };

    useEffect(() => {
        if (dadosCliente?.cpfValido) {
            type_account === 'correntista' &&
                loginCorrentistaOpus(dadosCliente.cpf).then(
                    ({ redirectUrl, sucesso }) => {
                        if (redirectUrl && sucesso) {
                            window.location.href = redirectUrl;
                            // eslint-disable-next-line
                            return;
                        }
                    },
                );

            type_account === 'naoCorrentista' &&
                loginNaoCorrentistaOpus(dadosCliente.cpf).then(
                    ({ redirectUrl, sucesso }) => {
                        if (redirectUrl && sucesso) {
                            window.location.href = redirectUrl;
                            // eslint-disable-next-line
                            return;
                        }
                    },
                );
        }
    }, [dadosCliente]);

    return (
        <>
            <ModalFormAcessoPJ
                setError={setError}
                isOpen={modalAcessoPj}
                setIsOpen={setModalAcessoPj}
            />
            {error && (
                <CustomModal
                    open={Boolean(error)}
                    title={LABELS.HEADER_ERRO_VALIDAR_CPF}
                    icon={<IconErro />}
                    body={
                        <Box>
                            <Box
                                marginTop={2}
                                marginBottom={2}
                                textAlign="center"
                            >
                                {LABELS[error.errorType]}
                            </Box>
                            <Box display="flex" justifyContent="center">
                                <CustomButton
                                    content={LABELS.BTN_VOLTAR}
                                    onClickCallBack={handleCloseErrorModal}
                                />
                            </Box>
                        </Box>
                    }
                    handleClose={handleCloseErrorModal}
                />
            )}
            <Box height="100vh" width="100vw" bgcolor="#fae128" />
            <ScreenLoader ref={handleLoader} />
        </>
    );
};

export default LoginOAuthBBOpin;
